<template>
  <section class="golf-reservation">
    <div class="reservation-panel">
      <div class="panel-heading">
        <div>
          <p class="eyebrow">GOLF OPERATIONS</p>
          <h2>Golf Reservation</h2>
        </div>
        <div class="reservation-status">
          <span class="status-dot"></span>
          Live schedule
        </div>
      </div>

      <div class="filters">
        <label class="field club-field">
          <span>Golf club</span>
          <select v-model="selectedClub">
            <option v-for="club in clubs" :key="club">{{ club }}</option>
          </select>
        </label>

        <div class="field schedule-mode">
          <span>Schedule mode</span>
          <div class="mode-options">
            <label><input v-model="scheduleMode" type="radio" value="normal"> Normal</label>
            <label><input v-model="scheduleMode" type="radio" value="simple"> Simple</label>
          </div>
        </div>

        <label class="field date-field">
          <span>Date</span>
          <div class="date-control">
            <button type="button" aria-label="Previous day" @click="moveDate(-1)"><i class="icon ion-chevron-left"></i></button>
            <input v-model="selectedDate" type="date">
            <button type="button" aria-label="Next day" @click="moveDate(1)"><i class="icon ion-chevron-right"></i></button>
          </div>
        </label>
      </div>

      <div class="notice"><i class="icon ion-information-circled"></i> Tee time availability is updated as reservations are confirmed.</div>

      <div class="tabs-actions">
        <div class="tabs" role="tablist">
          <button type="button" :class="{ active: activeTab === 'calendar' }" @click="activeTab = 'calendar'">Calendar</button>
          <button type="button" :class="{ active: activeTab === 'reservation' }" @click="activeTab = 'reservation'">Regular Reservation</button>
          <button type="button" :class="{ active: activeTab === 'groupReservation' }" @click="activeTab = 'groupReservation'">Group Reservation</button>
        </div>
        <div class="actions">
          <button type="button" class="btn-secondary" @click="moveDate(-1)"><i class="icon ion-arrow-left-c"></i> Previous</button>
          <button type="button" class="btn-primary" @click="addTeeTime"><i class="icon ion-plus-round"></i> Add tee time</button>
          <button type="button" class="btn-secondary" @click="moveDate(1)">Next <i class="icon ion-arrow-right-c"></i></button>
        </div>
      </div>

      <div v-if="activeTab === 'calendar'" class="schedule-wrap">
        <div class="schedule-legend">
          <span><i class="legend reserved"></i> Reserved</span>
          <span><i class="legend checkin"></i> Check in</span>
          <span><i class="legend checkout"></i> Check out</span>
          <span><i class="legend available"></i> Available</span>
        </div>

        <div class="schedule-table">
          <div class="schedule-head">
            <span>Time</span>
            <span v-for="teeBox in teeBoxes" :key="teeBox">{{ teeBox }}</span>
          </div>
          <div v-for="slot in slots" :key="slot.time" class="schedule-row">
            <div class="time-cell">
              {{ slot.time }}
              <small>{{ slot.period }}</small>
            </div>

            <div
              v-for="teeBox in teeBoxes"
              :key="teeBox"
              class="booking-cell"
            >
              <button
                v-for="playerIndex in playerSlots"
                :key="playerIndex"
                type="button"
                class="player-cell"
                :class="bookingClass(slot.bookings[teeBox] && slot.bookings[teeBox][playerIndex])"
                @click="selectBooking(slot, teeBox, playerIndex)"
                @contextmenu.prevent.stop="openPlayerMenu(slot, teeBox, playerIndex, $event)"
              >
                <template v-if="slot.bookings[teeBox] && slot.bookings[teeBox][playerIndex]">
                  <strong>{{ slot.bookings[teeBox][playerIndex].name }}</strong>
                  <span>{{ slot.bookings[teeBox][playerIndex].member }}</span>
                  <small>{{ slot.bookings[teeBox][playerIndex].status }}</small>
                </template>

                <template v-else>
                  <i class="icon ion-plus"></i>
                  <span>Player {{ playerIndex + 1 }}</span>
                </template>
              </button>
            </div>
          </div>
        </div>
      </div>

      <group-reservation
        v-else-if="activeTab === 'groupReservation'"
        :golf-club="selectedClub"
        :booking-date="selectedDate"
        @back="activeTab = 'calendar'"
      ></group-reservation>

      <regular-reservation
        v-else
        :golf-club="selectedClub"
        :booking-date="selectedDate"
        :reservation="selectedReservation"
        :selected-player="selectedPlayer"
        @back="activeTab = 'calendar'"
        @remove-player="removeSelectedPlayer"
      ></regular-reservation>

      <div
        v-if="playerMenu.visible"
        class="player-context-menu"
        :style="{ left: playerMenu.x + 'px', top: playerMenu.y + 'px' }"
        @click.stop
      >
        <button type="button" @click="handlePlayerMenuAction('view')">{{ contextPlayer ? 'View player' : 'Add player' }}</button>
        <button v-if="contextPlayer" type="button" @click="handlePlayerMenuAction('edit')">Edit reservation</button>
        <button v-if="contextPlayer" type="button" class="danger" @click="handlePlayerMenuAction('remove')">Remove player</button>
     </div>   
    </div>
  </section>
</template>

<script>
import GroupReservation from './GroupReservation.vue'
import RegularReservation from './RegulerReservation.vue'

const makeSlots = () => {
  const times = ['05:30', '05:38', '05:46', '05:54', '06:02', '06:10', '06:18', '06:26', '06:34', '06:42']
  const bookings = [
    { 'Tee box 1': [{ name: 'Fanny', member: 'GSK9 · 0000009819', status: 'Reserved', type: 'reserved' }, null, null, null], 'Tee box 2': [{ name: 'Uci', member: 'A001 · 0000009819', status: 'Checked in', type: 'checkin' }, null, null, null] },
    { 'Tee box 1': [{ name: 'Yudhi', member: 'MC18 · 0000009825', status: 'Reserved', type: 'reserved' }, null, null, null] },
    { 'Tee box 1': [{ name: 'Djoko', member: 'GSK9 · 0000009860', status: 'Checked in', type: 'checkin' }, null, null, null], 'Tee box 2': [{ name: 'Ardi', member: 'M001 · 0000009871', status: 'Checked out', type: 'checkout' }, null, null, null] },
    {}, {}, {}, {}, {}, {}, {}
  ]
  return times.map((time, index) => ({ time: time, period: index < 7 ? 'Morning' : 'Afternoon', bookings: bookings[index] }))
}

export default {
  name: 'GolfReservation',
  components: {
    GroupReservation,
    RegularReservation
  },
  data() {
    return {
      activeTab: 'calendar',
      clubs: ['Perfect Golf Course', 'Emerald Golf Club', 'Sentul Highlands Golf'],
      selectedClub: 'Perfect Golf Course',
      selectedDate: '2026-07-22',
      scheduleMode: 'normal',
      teeBoxes: ['Tee box 1', 'Tee box 2'],
      playerSlots: [0, 1, 2, 3],
      slots: makeSlots(),
      selectedReservation: {
        slot: null,
        teeBox: '',
        playerIndex: 0,
        time: ''
      },
      playerMenu: {
        visible: false,
        x: 0,
        y: 0,
        slot: null,
        teeBox: null,
        playerIndex: null
      }
    }
  },
  computed: {
    selectedPlayer() {
      if (!this.selectedReservation.slot) return null
      const players = this.selectedReservation.slot.bookings[this.selectedReservation.teeBox]
      return players ? players[this.selectedReservation.playerIndex] : null
    },
    contextPlayer() {
      if (!this.playerMenu.slot) return null
      const players = this.playerMenu.slot.bookings[this.playerMenu.teeBox]
      return players ? players[this.playerMenu.playerIndex] : null
    }
  },
  methods: {
    bookingClass(booking) {
      return booking ? 'is-' + booking.type : 'is-available'
    },
    moveDate(days) {
      const nextDate = new Date(this.selectedDate + 'T00:00:00')
      nextDate.setDate(nextDate.getDate() + days)
      this.selectedDate = nextDate.toISOString().slice(0, 10)
    },
    addTeeTime() {
      this.activeTab = 'calendar'
      this.$nextTick(() => {
        const firstAvailable = this.$el.querySelector('.is-available')
        if (firstAvailable) firstAvailable.focus()
      })
    },
    selectBooking(slot, teeBox, playerIndex) {
      let players = slot.bookings[teeBox]
      if (!players) {
        players = [null, null, null, null]
        this.$set(slot.bookings, teeBox, players)
      }
      if (!players[playerIndex]) {
        this.$set(players, playerIndex, { name: 'New player', member: 'Pending member ID', status: 'Draft reservation', type: 'reserved' })
      }
      this.selectedReservation = { slot: slot, teeBox: teeBox, playerIndex: playerIndex, time: slot.time }
      this.activeTab = 'reservation'
    },
    openPlayerMenu(slot, teeBox, playerIndex, event) {
      this.playerMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        slot: slot,
        teeBox: teeBox,
        playerIndex: playerIndex
      }
    },
    closePlayerMenu() {
      this.playerMenu.visible = false
    },
    handlePlayerMenuAction(action) {
      const menu = this.playerMenu
      if (action === 'remove') {
        const players = menu.slot.bookings[menu.teeBox]
        this.$set(players, menu.playerIndex, null)
        this.selectedReservation = { slot: null, teeBox: '', playerIndex: 0, time: '' }
      } else {
        this.selectBooking(menu.slot, menu.teeBox, menu.playerIndex)
      }
      this.closePlayerMenu()
    },
    removeSelectedPlayer() {
      if (!this.selectedReservation.slot) return
      const players = this.selectedReservation.slot.bookings[this.selectedReservation.teeBox]
      this.$set(players, this.selectedReservation.playerIndex, null)
      this.selectedReservation = { slot: null, teeBox: '', playerIndex: 0, time: '' }
      this.activeTab = 'calendar'
    }
  }
}
</script>

<style scoped>
.golf-reservation { padding: 0 15px 24px; color: #263547; }
.reservation-panel { background: #fff; border-radius: 10px; box-shadow: 0 2px 12px rgba(24, 54, 80, .12); overflow: hidden; }
.panel-heading { display: flex; align-items: center; justify-content: space-between; padding: 20px 24px; border-bottom: 1px solid #e7edf2; }
.eyebrow { margin: 0 0 3px; color: #6c8398; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; }
h2 { margin: 0; color: #193750; font-size: 24px; font-weight: 600; }
.reservation-status { color: #5e7285; font-size: 13px; }
.status-dot { display: inline-block; width: 8px; height: 8px; margin-right: 6px; border-radius: 50%; background: #40a66b; }
.filters { display: flex; gap: 22px; align-items: flex-end; padding: 20px 24px 16px; background: #f9fbfc; }
.field { display: flex; flex-direction: column; gap: 7px; color: #607487; font-size: 12px; font-weight: 700; text-transform: uppercase; }
.club-field { flex: 1; }
.field select, .field input { min-height: 38px; padding: 8px 11px; border: 1px solid #ccd8e1; border-radius: 5px; color: #263547; font-size: 14px; font-weight: 400; text-transform: none; background: #fff; }
.schedule-mode { min-width: 185px; }
.mode-options { display: flex; gap: 14px; min-height: 38px; align-items: center; color: #34495e; font-size: 14px; font-weight: 400; text-transform: none; }
.mode-options input { min-height: auto; margin: 0 5px 0 0; accent-color: #198f69; }
.date-field { min-width: 265px; }
.date-control { display: flex; }
.date-control input { width: 100%; border-radius: 0; }
.date-control button { width: 38px; border: 1px solid #ccd8e1; color: #39719a; background: #fff; }
.date-control button:first-child { border-radius: 5px 0 0 5px; }
.date-control button:last-child { border-radius: 0 5px 5px 0; }
.notice { margin: 0 24px; padding: 10px 12px; border-radius: 5px; color: #756235; background: #fff8dc; font-size: 13px; }
.notice i { margin-right: 7px; color: #d0a735; }
.tabs-actions { display: flex; justify-content: space-between; gap: 15px; align-items: center; padding: 22px 24px 14px; }
.tabs { display: flex; border-bottom: 1px solid #dce5eb; }
.tabs button { padding: 9px 14px; border: 0; border-bottom: 2px solid transparent; color: #718293; background: transparent; font-size: 14px; }
.tabs button.active { border-color: #198f69; color: #176b52; font-weight: 700; }
.actions { display: flex; gap: 8px; }
.actions button, .reservation-empty button { min-height: 34px; padding: 7px 12px; border-radius: 4px; font-size: 13px; }
.btn-primary { border: 1px solid #187c5d; color: #fff; background: #198f69; }
.btn-secondary { border: 1px solid #cfd9e0; color: #49677f; background: #fff; }
.schedule-wrap { padding: 0 24px 24px; overflow-x: auto; }
.schedule-legend { display: flex; gap: 18px; margin: 0 0 12px; color: #62778b; font-size: 12px; }
.legend { display: inline-block; width: 9px; height: 9px; margin-right: 5px; border-radius: 50%; }.reserved { background: #e77c86; }.checkin { background: #5baee5; }.checkout { background: #d1a35b; }.available { background: #dfe8ed; }
.schedule-table { min-width: 760px; border: 1px solid #d7e1e7; border-radius: 6px; overflow: hidden; }
.schedule-head, .schedule-row { display: grid; grid-template-columns: 112px repeat(2, minmax(270px, 1fr)); }
.schedule-head { color: #fff; background: #1f668d; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; }
.schedule-head span { padding: 12px 15px; border-right: 1px solid rgba(255,255,255,.22); text-align: center; }.schedule-head span:first-child { text-align: left; }
.schedule-row { min-height: 76px; border-top: 1px solid #e2e9ed; background: #fff; }
.schedule-row:nth-child(odd) { background: #fbfcfd; }
.time-cell { display: flex; flex-direction: column; justify-content: center; padding: 12px 15px; color: #244c6a; font-size: 19px; font-weight: 700; background: #eff6f9; }
.time-cell small { margin-top: 2px; color: #8095a5; font-size: 10px; font-weight: 400; text-transform: uppercase; }
.booking-cell {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* setiap item minimal 100px, lalu membagi ruang */
  gap: 10px;
  border-left: 1px solid #e2e9ed;
}
.player-cell { display: inline-flex; flex-direction: column; justify-content: center; align-items: flex-start; gap: 2px; min-height: 52px; padding: 7px 10px; border: 0; border-right: 1px solid #e2e9ed; border-bottom: 1px solid #e2e9ed; text-align: left; background: transparent; transition: background .15s ease; width: auto; box-sizing: border-box; }
.player-cell:nth-child(2n) { border-right: 0; }.player-cell:nth-last-child(-n+2) { border-bottom: 0; }
.player-cell strong { color: #344d63; font-size: 12px; }.player-cell span { color: #688095; font-size: 10px; }.player-cell small { font-size: 9px; font-weight: 700; text-transform: uppercase; }
.player-cell.is-reserved { box-shadow: inset 3px 0 #e77c86; background: #fff4f5; }.player-cell.is-reserved small { color: #bd5260; }
.player-cell.is-checkin { box-shadow: inset 3px 0 #5baee5; background: #f1f9fe; }.player-cell.is-checkin small { color: #2c87bd; }
.player-cell.is-checkout { box-shadow: inset 3px 0 #d1a35b; background: #fffbf3; }.player-cell.is-checkout small { color: #a57529; }
.player-cell.is-available { align-items: center; color: #93a4b1; }.player-cell.is-available i { font-size: 13px; }.player-cell.is-available:hover { color: #198f69; background: #f1fbf7; }
.reservation-empty { padding: 58px 20px 68px; color: #789; text-align: center; }.reservation-empty > i { color: #89a8bd; font-size: 42px; }.reservation-empty h3 { margin: 10px 0 5px; color: #38576d; }.reservation-empty p { margin: 0 0 18px; }
@media (max-width: 767px) { .filters, .tabs-actions { flex-direction: column; align-items: stretch; }.field, .date-field, .schedule-mode { min-width: 0; }.actions { justify-content: space-between; }.panel-heading { padding: 16px; }.schedule-wrap { padding: 0 16px 16px; }.notice { margin: 0 16px; } }
.player-cell.is-checkin { box-shadow: inset 3px 0 #5baee5; background: #f1f9fe; }.player-cell.is-checkin small { color: #2c87bd; }
.player-cell.is-checkout { box-shadow: inset 3px 0 #d1a35b; background: #fffbf3; }.player-cell.is-checkout small { color: #a57529; }
.player-cell.is-available { align-items: center; color: #93a4b1; }.player-cell.is-available i { font-size: 13px; }.player-cell.is-available:hover { color: #198f69; background: #f1fbf7; }
.reservation-empty { padding: 58px 20px 68px; color: #789; text-align: center; }.reservation-empty > i { color: #89a8bd; font-size: 42px; }.reservation-empty h3 { margin: 10px 0 5px; color: #38576d; }.reservation-empty p { margin: 0 0 18px; }
@media (max-width: 767px) { .filters, .tabs-actions { flex-direction: column; align-items: stretch; }.field, .date-field, .schedule-mode { min-width: 0; }.actions { justify-content: space-between; }.panel-heading { padding: 16px; }.schedule-wrap { padding: 0 16px 16px; }.notice { margin: 0 16px; } }
.regular-reservation { padding: 22px 24px 26px; }.reservation-tab-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }.reservation-tab-heading h3 { margin: 0; color: #284a63; font-size: 20px; }.reservation-badge { padding: 5px 10px; border-radius: 12px; color: #277253; font-size: 12px; font-weight: 700; background: #e4f6ec; }
.reservation-form-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; padding: 18px; border: 1px solid #d8e3e9; border-radius: 6px; background: #fafcfd; }.form-section { display: flex; flex-direction: column; gap: 9px; }.form-section > label, .form-pair label { display: grid; grid-template-columns: 112px minmax(0, 1fr); align-items: center; gap: 8px; color: #546a7c; font-size: 12px; font-weight: 700; }.form-section input, .form-section select, .form-section textarea { width: 100%; min-height: 31px; padding: 6px 8px; border: 1px solid #cedae2; border-radius: 3px; color: #334c60; font-size: 12px; font-weight: 400; background: #fff; }.form-section input[readonly] { color: #697c8b; background: #edf1f4; }.form-section textarea { resize: vertical; }.form-pair { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; }.form-pair label { grid-template-columns: 1fr; gap: 4px; }
.reservation-actions { display: flex; justify-content: flex-end; gap: 8px; margin: 16px 0 22px; }.reservation-actions button { min-height: 34px; padding: 7px 12px; border-radius: 4px; font-size: 13px; }.player-list-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }.player-list-heading h4 { margin: 0; color: #38576d; font-size: 15px; }.player-list-heading span { color: #7c8d99; font-size: 12px; }.player-list-table { border: 1px solid #bfd4e1; border-radius: 5px; overflow: hidden; }.player-list-head, .player-list-row { display: grid; grid-template-columns: 1.1fr .7fr 1.5fr .8fr 1fr 1fr 1fr; }.player-list-head { color: #235676; font-size: 11px; font-weight: 700; background: #e0f0fa; }.player-list-head span, .player-list-row span { padding: 9px 8px; border-right: 1px solid #bfd4e1; }.player-list-row { color: #5a4a26; font-size: 12px; background: #fff3ca; }.player-list-placeholder { padding: 20px; color: #82929e; font-size: 13px; text-align: center; }
.player-context-menu { position: fixed; z-index: 1100; min-width: 155px; padding: 5px 0; border: 1px solid #d1dce4; border-radius: 5px; box-shadow: 0 5px 16px rgba(24, 54, 80, .2); background: #fff; }.player-context-menu button { display: block; width: 100%; padding: 8px 13px; border: 0; color: #3d5568; text-align: left; font-size: 13px; background: #fff; }.player-context-menu button:hover { color: #176b52; background: #eef7f4; }.player-context-menu button.danger { color: #b74c54; }.player-context-menu button.danger:hover { background: #fff3f4; }
@media (max-width: 980px) { .reservation-form-grid { grid-template-columns: 1fr; }.form-section > label { grid-template-columns: 125px minmax(0, 1fr); } }
@media (max-width: 767px) { .filters, .tabs-actions { flex-direction: column; align-items: stretch; }.field, .date-field, .schedule-mode { min-width: 0; }.actions { justify-content: space-between; }.panel-heading, .regular-reservation { padding: 16px; }.schedule-wrap { padding: 0 16px 16px; }.notice { margin: 0 16px; }.player-list-table { overflow-x: auto; }.player-list-head, .player-list-row { min-width: 690px; }.reservation-actions { justify-content: stretch; }.reservation-actions button { flex: 1; } }

</style>



// WEBPACK FOOTER //
// GolfReservation.vue?2656dfaa